import { Injectable } from '@angular/core';
import { BaseFacade } from '../base/base.facade';
import { TranslateService } from '@ngx-translate/core';
import { DynamicSchemaFactory } from '../dynamic-schema.factory';
import { AppTokenService } from '../../../app-token.service';
import { MenuService } from './menu.service';
import { MenuStore } from './menu.store';
import { MenuQuery } from './menu.query';

@Injectable({ providedIn: 'root' })
export class MenuFacade extends BaseFacade {

  constructor(
    private readonly menuService: MenuService,
    menuStore: MenuStore,
    menuQuery: MenuQuery,
    dynamicSchemaFacto: DynamicSchemaFactory,
    translateService: TranslateService) {
    super(menuService,
      menuStore,
      menuQuery,
      dynamicSchemaFacto.getDynamicSchemaFacade(AppTokenService.MENU_SCHEMA_NAME),
      translateService,
      AppTokenService.MENU_SCHEMA_NAME + '-facade'
      );
  }
}
